module.exports = __webpack_public_path__ + "static/media/collaborative-practice.14022187.md";